// FLAVORS DATA
  const FLAVORS = {
    watermelon: {
      name: 'Watermelon Lemonade',
      tease: 'The one everybody wants a lick of.',
      img: 'https://cdn.shopify.com/s/files/1/0537/4092/9206/files/leatherdaddy-skin-co-bath-body-watermelon-lemonade-tastyhole-flavored-body-scrub-watermelon-lemonade-tastyhole-flavored-body-scrub-1204977367.png?v=1764121501',
      variant: '42207723978934',
      tag: 'On sale'
    },
    donut: {
      name: 'Glazed Donut Hole',
      tease: 'Warm, glazed, freshly finished.',
      img: 'https://cdn.shopify.com/s/files/1/0537/4092/9206/files/tastyhole-body-scrub-bath-body-glazed-donut-hole-tastyhole-flavored-body-scrub-tastyhole-flavored-body-scrubs-glazed-donut-hole-sq9568602-749350681773-1204977371.png?v=1764121647',
      variant: '40356759666870',
      tag: 'Fresh batch'
    },
    peach: {
      name: 'Peach Ring',
      tease: 'Snug, sweet, made to be stretched.',
      img: 'https://cdn.shopify.com/s/files/1/0537/4092/9206/files/tastyhole-body-scrub-bath-body-peach-ring-tastyhole-flavored-body-scrub-tastyhole-flavored-body-scrub-peach-ring-sq3598217-749350681766-1204977369.png?v=1764121619',
      variant: '40356764025014',
      tag: 'Fan favorite'
    },
    cherry: {
      name: 'Cherry Gobbler',
      tease: 'Deep, dark, worth gobbling up.',
      img: 'https://cdn.shopify.com/s/files/1/0537/4092/9206/files/tastyhole-body-scrub-body-cherry-gobbler-tastyhole-flavored-body-scrub-tastyhole-flavored-body-scrubs-cherry-gobbler-sq2241265-749350681780-1204977370.png?v=1764121674',
      variant: '40356760354998',
      tag: 'Grown-up pick'
    },
    latte: {
      name: 'Hot Vanilla Latte',
      tease: 'Hot, creamy, best served slow.',
      img: 'https://cdn.shopify.com/s/files/1/0537/4092/9206/files/leatherdaddy-skin-co-body-scrub-hot-vanilla-latte-tastyhole-flavored-body-scrub-tastyhole-flavored-body-scrubs-hot-vanilla-latte-sq6412538-749350681797-1204977368.png?v=1764121592',
      variant: '40356760551606',
      tag: 'Warm & creamy'
    },
    lemon: {
      name: 'Lemon Pound Cake',
      tease: 'Zesty on top, buttery underneath.',
      img: 'https://cdn.shopify.com/s/files/1/0537/4092/9206/files/tastyhole-body-scrub-body-scrub-lemon-pound-cake-tastyhole-flavored-body-scrub-lemon-pound-cake-tastyhole-flavored-body-scrub-1204977366.png?v=1764121469',
      variant: '42207725125814',
      tag: 'Bright & buttery'
    }
  };
  const ORDER = ['watermelon','donut','peach','cherry','latte','lemon'];

  // Picker (top section)
  const flavorTags = Object.fromEntries(Object.entries(FLAVORS).map(([k,v])=>[k,v.tag]));
  const pickerBtns = document.querySelectorAll('.picker-btn');
  const pickerImages = document.querySelectorAll('.flavor-img');
  const pickerCopies = document.querySelectorAll('.flavor-copy');
  const tagEl = document.getElementById('flavor-tag');
  pickerBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const flavor = btn.dataset.flavor;
      pickerBtns.forEach(b => { b.classList.remove('active'); b.setAttribute('aria-selected','false'); });
      btn.classList.add('active'); btn.setAttribute('aria-selected','true');
      pickerImages.forEach(i => i.classList.toggle('active', i.dataset.flavor === flavor));
      pickerCopies.forEach(c => c.classList.toggle('active', c.dataset.flavor === flavor));
      tagEl.textContent = flavorTags[flavor] || '';
    });
  });

  // Countdown to Fri Aug 21, 2026 11:59 PM MDT (05:59 UTC Aug 22)
  const endTime = new Date('2026-08-22T05:59:00Z').getTime();
  const d = document.getElementById('cd-days');
  const h = document.getElementById('cd-hours');
  const m = document.getElementById('cd-mins');
  const s = document.getElementById('cd-secs');
  function pad(n){return String(n).padStart(2,'0')}
  function tick(){
    const now = Date.now();
    let diff = Math.max(0, Math.floor((endTime - now)/1000));
    const days = Math.floor(diff/86400); diff -= days*86400;
    const hrs = Math.floor(diff/3600); diff -= hrs*3600;
    const mins = Math.floor(diff/60);
    const secs = diff - mins*60;
    d.textContent = pad(days); h.textContent = pad(hrs);
    m.textContent = pad(mins); s.textContent = pad(secs);
  }
  tick(); setInterval(tick, 1000);

  // BUNDLE BUILDER
  const grid = document.getElementById('bundleGrid');
  const progressSlots = document.querySelectorAll('#bundleProgress .slot');
  const bCount = document.getElementById('bCount');
  const bDeal = document.getElementById('bDeal');
  const bMsg = document.getElementById('bMsg');
  const bCheckout = document.getElementById('bCheckout');
  const bReset = document.getElementById('bReset');
  const stickybar = document.getElementById('stickybar');
  const stickyTxt = document.getElementById('stickyTxt');
  const stickyCta = document.getElementById('stickyCta');
  const MAX = 3;
  let bundle = [];

  function renderCards(){
    grid.innerHTML = ORDER.map(key => {
      const f = FLAVORS[key];
      return `
        <div class="b-card" data-flavor="${key}" role="button" tabindex="0" aria-pressed="false">
          <div class="b-num">1</div>
          <div class="b-check">+</div>
          <div class="b-card-img"><img src="${f.img}" alt="${f.name}"></div>
          <div class="b-card-body">
            <div class="b-card-name">${f.name}</div>
            <div class="b-card-tease">${f.tease}</div>
          </div>
        </div>`;
    }).join('');
    grid.querySelectorAll('.b-card').forEach(card => {
      card.addEventListener('click', () => toggle(card.dataset.flavor));
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(card.dataset.flavor); }
      });
    });
  }

  function toggle(flavor){
    const idx = bundle.indexOf(flavor);
    if (idx >= 0) {
      bundle.splice(idx,1);
    } else {
      if (bundle.length >= MAX) return;
      bundle.push(flavor);
    }
    render();
  }

  function addFromPicker(flavor){
    if (bundle.includes(flavor)) {
      // scroll to bundle instead
    } else if (bundle.length < MAX) {
      bundle.push(flavor);
    }
    render();
    document.getElementById('bundle').scrollIntoView({behavior:'smooth', block:'start'});
  }

  function render(){
    // cards
    grid.querySelectorAll('.b-card').forEach(card => {
      const key = card.dataset.flavor;
      const pos = bundle.indexOf(key);
      const selected = pos >= 0;
      card.classList.toggle('selected', selected);
      card.setAttribute('aria-pressed', selected ? 'true' : 'false');
      card.classList.toggle('disabled', !selected && bundle.length >= MAX);
      card.querySelector('.b-num').textContent = selected ? (pos+1) : '';
      card.querySelector('.b-check').textContent = selected ? '✓' : '+';
    });
    // slots
    progressSlots.forEach((slot, i) => {
      const key = bundle[i];
      if (key) {
        slot.classList.add('filled');
        slot.innerHTML = `<img src="${FLAVORS[key].img}" alt="${FLAVORS[key].name}">`;
      } else {
        slot.classList.remove('filled');
        slot.textContent = (i+1);
      }
    });
    // stats
    bCount.textContent = `${bundle.length} / 3`;
    if (bundle.length === MAX) {
      bDeal.textContent = '33% off unlocked';
      bMsg.textContent = 'Ready. Discount auto-applies at checkout.';
      bMsg.classList.add('ready');
      bCheckout.textContent = 'Checkout with 33% off';
      bCheckout.removeAttribute('aria-disabled');
      const variantList = bundle.map(k => FLAVORS[k].variant + ':1').join(',');
      bCheckout.setAttribute('href', `https://leatherdaddyskin.com/cart/${variantList}`);
    } else {
      bDeal.textContent = bundle.length === 0 ? 'Locked' : `Pick ${MAX - bundle.length} more`;
      bMsg.textContent = bundle.length === 0
        ? 'Pick 3 flavors to unlock 33% off.'
        : `${MAX - bundle.length} to go. Auto-applies at checkout.`;
      bMsg.classList.remove('ready');
      bCheckout.textContent = bundle.length === 0 ? 'Choose 3 first' : `Add ${MAX - bundle.length} more`;
      bCheckout.setAttribute('aria-disabled', 'true');
      bCheckout.setAttribute('href', '#bundle');
    }
    // stickybar
    if (bundle.length > 0) {
      stickybar.classList.add('show');
      if (bundle.length === MAX) {
        stickyTxt.innerHTML = `Bundle ready<small>33% off auto-applied at checkout</small>`;
        stickyCta.textContent = 'Checkout';
        stickyCta.setAttribute('href', bCheckout.getAttribute('href'));
      } else {
        stickyTxt.innerHTML = `${bundle.length} / 3 jars picked<small>${MAX - bundle.length} more to unlock 33% off</small>`;
        stickyCta.textContent = 'Keep picking';
        stickyCta.setAttribute('href', '#bundle');
      }
    } else {
      stickybar.classList.remove('show');
    }
  }

  bReset.addEventListener('click', () => { bundle = []; render(); });

  // Picker "Add to bundle" buttons
  document.querySelectorAll('[data-add]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      addFromPicker(btn.dataset.add);
    });
  });

  renderCards();
  render();